<template>
    <div v-if="canUpdate">
        <settings-heading
            :title="$t('settings.favicon.title')"
            :description="$t('settings.favicon.description')"
        />

        <siu
            v-model="form.favicon_path_queued_id"
            :image="imageUrl"
            :isSquare="true"
            :minHeight="300"
            :minWidth="300"
            class="mb-48"
            classes="h-240 rounded-6 shadow-md"
            icon-location="corner"
            @clear="clearPhoto"
            @success="resetPhoto">
        </siu>

        <div class="flex justify-end mb-48">
            <simple-button
                :disabled="!form.isDirty()"
                display="secondary"
                icon="save"
                :loading="form.submitting"
                look="primary"
                @click="submitForm"
            >
                {{ $t('settings.save') }}
            </simple-button>
        </div>

    </div>
    <error-403 v-else></error-403>
</template>

<script>
import SimpleButton from '../../components/ui/SimpleButton.vue';
import Form from '../../etc/forms/Form';
import {mapState, mapActions} from 'pinia';
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../../state/store';
import {useNotificationsStore} from '../../state/modules/notifications';
import * as jobsiteService from '../../services/JobsiteService';
import Jobsite from '../../models/Jobsite';
import {ADD_NOTIFICATION} from '../../state/mutation-types';
import {normalizeJson} from '../../../shared/helpers';
import SingleImageUpload from '../../components/forms/SingleImageUpload.vue';
import Error403 from '../../components/ui/Error403.vue';
import SettingsHeading from "../../components/ui/SettingsHeading.vue";

export default {
    components: {
        SettingsHeading,
        'simple-button': SimpleButton,
        'siu': SingleImageUpload,
        'error-403': Error403,
    },
    computed: {
        ...mapState(useMainStore, ['currentCompany']),
        imageUrl() {
            return (typeof this.currentCompany.jobsite.favicon_url) ?
                this.currentCompany.jobsite.favicon_url :
                null;
        },
    },
    data: function () {
        return {
            form: this.generateForm(),
            canUpdate: this.$can('settings.jobsite'),
        }
    },
    methods: {
        ...mapActions(useNotificationsStore, [ADD_NOTIFICATION]),
        generateForm() {
            return new Form([
                {name: 'favicon_path', value: 'default'},
                {name: 'favicon_path_queued_id', value: null},
            ]);
        },
        async submitForm() {
            this.form.submitting = true;

            if (this.form.data.favicon_path_queued_id === null) {
                delete this.form.data.favicon_path_queued_id;
            }

            if (this.form.data.favicon_path === 'default') {
                delete this.form.data.favicon_path;
            }
            await this.form.submit(data => {
                return jobsiteService.update(this.currentCompany.id, {data: {attributes: data}});
            }).then(result => {
                return useRepo(Jobsite)
                    .whereId(result.id)
                    .update(normalizeJson(result));
            }).then(() => {
                this.form = this.generateForm();
                this[ADD_NOTIFICATION]({
                    type: 'success',
                    message: this.$t('settings.saved', {subject: this.$t('settings.favicon.title')}),
                });
            });

            this.form.submitting = false;
        },
        clearPhoto() {
            this.form.data.favicon_path = null;
        },
        resetPhoto() {
            this.form.data.favicon_path = 'default';
        },
    },
};
</script>
